import {UploadedFile} from '@ui/utils/files/uploaded-file';
import {createUploadInput} from '@ui/utils/files/create-upload-input';
import {FileInputConfig} from '@ui/utils/files/file-input-config';
import { driveState } from '@app/drive/drive-store';

function createLazyFileArray(fileList: FileList): UploadedFile[] {
  const target: any = [];
  target.length = fileList.length;

  target[Symbol.asyncIterator] = async function* () {
    for (let i = 0; i < fileList.length; i++) {
      const file = fileList[i];
      if (file.name !== '.DS_Store') {
        yield new UploadedFile(file);
      }
    }
  };

  const cache = new Map<number, UploadedFile>();

  return new Proxy(target, {
    get(t, prop) {
      if (prop === Symbol.asyncIterator) {
        return t[Symbol.asyncIterator];
      }
      if (prop === 'length') {
        return fileList.length;
      }
      if (typeof prop === 'string') {
        const index = parseInt(prop, 10);
        if (!isNaN(index) && index >= 0 && index < fileList.length) {
          if (!cache.has(index)) {
            cache.set(index, new UploadedFile(fileList[index]));
          }
          return cache.get(index);
        }
      }
      return Reflect.get(t, prop);
    }
  }) as any;
}

/**
 * Open browser dialog for uploading files and
 * resolve promise with uploaded files.
 */
export function openUploadWindow(
  config: FileInputConfig = {},
): Promise<UploadedFile[]> {
  return new Promise(resolve => {

    const input = createUploadInput(config);

    input.onchange = e => {
      const fileList = (e.target as HTMLInputElement).files;
      if (!fileList) {
        return resolve([]);
      }

      const uploads = createLazyFileArray(fileList);
      resolve(uploads);
      input.remove();
    };

    document.body.appendChild(input);
    input.click();
  });
}
